<template>
  <v-form
    ref="form"
    v-model="valid"
    lazy-validation
  >
    <v-dialog
      v-model="show"
      :max-width="$store.state.mobile ? '' : 440"
      :fullscreen="$store.state.mobile"
      @click:outside="$emit('update:close')"
    >
      <v-card>
        <v-card-title class="headline font-medium">
          <template v-if="$store.getters.languageGetter === '1'">
            تسجيل دخول
          </template>
          <template v-else>
            Sign In
          </template>
          <v-spacer />
          <v-icon
            size="24px"
            @click="$emit('update:close')"
          >
            mdi-close
          </v-icon>
        </v-card-title>
        <v-divider />
        <v-card-text class="pt-4 pb-0">
          <div class="text-h6 text--primary">
            <template v-if="$store.getters.languageGetter === '1'">
              البريد الإلكتروني
            </template>
            <template v-else>
              Email
            </template>
          </div>
          <v-text-field
            v-model="email"
            outlined
            dense
            required
            clearable
            hide-details
            :rules="emailRules"
          />
          <div class="text-h6 text--primary mt-2">
            <template v-if="$store.getters.languageGetter === '1'">
              كلمة المرور
            </template>
            <template v-else>
              Password
            </template>
          </div>
          <v-text-field
            v-model="password"
            outlined
            type="password"
            dense
            clearable
            hide-details
            required
            :rules="passwordRules"
          />
          <div class="mt-2">
            <template v-if="$store.getters.languageGetter === '1'">
              السرهل نسيت كلمة
            </template>
            <template v-else>
              Forget password
            </template>
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-icon
                  small
                  color="#555"
                  v-bind="attrs"
                  v-on="on"
                >
                  mdi-help-circle-outline
                </v-icon>
              </template>
              <span><template v-if="$store.getters.languageGetter === '1'">
                      الرجاء التواصل
                    </template>
                <template v-else>
                  Please contact
                </template>{{ $store.state.webConfig.mobile ? $store.state.webConfig.mobile : $store.getters.languageGetter === '1' ? 'نحن' : 'us' }}</span>
            </v-tooltip>
          </div>
          <v-checkbox
            v-model="saveToLocal"
            hide-details
            :label="$store.getters.languageGetter === '1' ? 'ابق مسجلا الدخول' : 'Stay signed in'"
            class="checkbox-sm"
          />
          <div
            style="padding-left:24px"
            class="subtitle"
          >
            <template v-if="$store.getters.languageGetter === '1'">
              حماية خصوصيتك - تسجيل الخروج عند الانتهاء.
            </template>
            <template v-else>
              Protect your privacy - sign out when you're done.
            </template>
          </div>
        </v-card-text>
        <v-card-actions class="px-6 py-4">
          <v-btn
            :disabled="!valid"
            :loading="submitting"
            color="primary"
            depressed
            @click="logIn"
          >
            <template v-if="$store.getters.languageGetter === '1'">
              تسجيل دخول
            </template>
            <template v-else>
              Sign in
            </template>
          </v-btn>
          <v-btn
            color="primary"
            text
            outlined
            to="/register"
          >
            <template v-if="$store.getters.languageGetter === '1'">
              انضم مجانا
            </template>
            <template v-else>
              Join Free
            </template>
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-form>
</template>

<script>
import { mapActions } from 'vuex';

export default {
  name: 'LogIn',
  props: {
    show: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      valid: true,
      submitting: false,
      email: '',
      emailRules: [(v) => !!v || 'Please enter your email', (v) => /\w[-\w.+]*@([A-Za-z0-9][-A-Za-z0-9]+\.)+[A-Za-z]{2,14}/.test(v)
          || 'This is not a correct email address'],
      password: '',
      passwordRules: [(v) => !!v || 'Please enter your password', (v) => v.length >= 6 || 'Password should be more than 6 characters'],
      saveToLocal: false,
    };
  },
  methods: {
    ...mapActions(['logInAsync']),
    logIn() {
      if (this.$refs.form.validate()) {
        this.submitting = true;
        this.logInAsync({ account: this.email, password: this.$store.$md5(this.password), save: this.saveToLocal }).then(() => {
          // this.$store.commit('TOGGLE_SNACKBAR', {
          //   type: 'success',
          //   text: 'Success',
          // });
          this.$emit('update:close');
          // this.$router.push({ name: 'UserDashboard' });
        }).finally(() => {
          this.submitting = false;
        });
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.v-input .v-label {
  font-size: 1rem !important;
}
</style>
